import styled from "styled-components";

const ConsentCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 26px 32px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};
  border: ${({ theme }) => theme.cardBorder ?? "none"};
  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    padding: 26px 16px;
  }
`;

export default ConsentCard;
